<nrwl-identity-verification
    #identityVerification
    [error]="activeError"
    [phoneNumber]="phoneNumber"
    (entered)="onCodeEntered($event)" 
    (resend)="onResendClicked($event)"
    (action)="onErrorAction($event)"
>

    <ng-container title>
        Identity verification
    </ng-container>

    <ng-container description>
        Enter the code that was sent to (***) ***-{{ phoneNumber }}.
    </ng-container>

</nrwl-identity-verification>

<pn-spinner [color]="'#FFFFFF;'" [visible]="isLoading" name="identity_verification_spinner"></pn-spinner>
